import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.506 1.425A.5.5 0 0 1 6 1h6.975a5.5 5.5 0 0 1 5.098 3.432 3.3 3.3 0 0 0-.951-.147H8.46a.5.5 0 0 0-.495.425L5.875 18.5H3.5a.5.5 0 0 1-.494-.575zm1.358 17.557.073-.482v-.004l1.01-6.996h5.998c2.888 0 5.212-2.32 5.476-5.038A5.5 5.5 0 0 1 16.31 16.5h-4.045l-.935 6.076a.5.5 0 0 1-.494.424h-4a.5.5 0 0 1-.495-.575l.185-1.215.337-2.228ZM18.411 5.65q.02.133.035.267c.017 2.414-1.994 4.583-4.501 4.583H8.099l.79-5.215h8.233c.413 0 .85.134 1.289.365",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandPaymentsPaypal = { render };
export {
  brandPaymentsPaypal as default,
  render
};
//# sourceMappingURL=brand-payments-paypal.svg.js.map
